import { Box } from "@mui/material";
import type React from "react";
import { KeyboardShortcutLabel } from "src/components/common/keyboard/KeyboardShortcutLabel.tsx";
import type { KeyboardShortcut } from "src/utils/useKeyboardShortcut.ts";

interface KeyboardShortcutTooltipLabelProps {
	label: React.ReactNode;
	shortcut: KeyboardShortcut;
}

export function KeyboardShortcutTooltipLabel({ label, shortcut }: KeyboardShortcutTooltipLabelProps) {
	return (
		<Box component={"span"} sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
			<Box component={"span"}>{label}</Box>
			<KeyboardShortcutLabel shortcut={shortcut} />
		</Box>
	);
}
